import { IErrorFieldsFragment } from './graphqlSchema';
import toastMessage from '../toastMessage';

/**
 * Displays a toast message for each error in the arguments
 *
 * Returns true if there are any errors
 *
 * @param errors
 */
export default (errors?: Array<IErrorFieldsFragment>) => {
  if (!errors?.length) {
    return false;
  }

  console.error(errors);

  let hasErrors = false;
  for (const { messages } of errors) {
    for (const message of messages) {
      toastMessage({ message, type: 'error' });
      hasErrors = true;
    }
  }

  return hasErrors;
};
